import { render, staticRenderFns } from "./Pagination-user.vue?vue&type=template&id=3a3d0b98"
import script from "./Pagination-user.vue?vue&type=script&lang=js"
export * from "./Pagination-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports